import React, { useState } from "react";

const Lesson = ({ lesson }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { headline, media } = lesson;

  const loadImage = () => {
    setIsLoading(false);
  };

  return (
    <>
      <div className="card text-center mt-3 pb-2" style={{ width: "70vw" }}>
        <div className="card-body">
          <p className="card-text display-3">{headline}</p>
          {isLoading && (
            <>
              <div className="spinner-grow" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </>
          )}

          <img
            className="card-img-top"
            src={media}
            alt="microlessons"
            onLoad={loadImage}
            style={{
              height: "55vh",
              width: "45vw",
              alignSelf: "center",
              borderRadius: "5%",
              display: isLoading ? "none" : "inline",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Lesson;
